import { getUid } from '../util/index';

const useReactLogger = () => {
  const log = (message, customAttributes = {}) => {
    const newRelic = window.newrelic || undefined;
    if(newRelic){
      const defaultCustomAttributes = {
        application: process.env.REACT_APP_NEWRELIC_APP_NAME || '',
      };

      const sessionId = getUid(window.location.search);
      const uid = sessionId ? ` uid = ${sessionId}` : '';
      newRelic.log?.(`${message}${uid}`, {
        customAttributes: {
          ...defaultCustomAttributes,
          uid: sessionId,
          ...customAttributes,
        },
      });
    }
  };

  return {
    log,
  };
};

export default useReactLogger;